import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { saveSelectedSignupRole } from "../store/signupStorage";
import { BACKARROW } from "../components/Icons";
import Student from "../assets/student-signup.png";
import Instructor from "../assets/instructor-signup.png";
import { AuthNavBar } from "../components/Navbar";

const roleOptions = [
  {
    value: "student",
    label: "Student",
    icon: Student,
  },
  {
    value: "teacher",
    label: "Teacher",
    icon: Instructor,
  },
];

const SignUp = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState("");

  const handleRoleSelect = (roleValue) => {
    setSelectedRole(roleValue);
    saveSelectedSignupRole(roleValue);

    if (roleValue === "student") {
      navigate("/signup/student-registration");
      return;
    }

    navigate("/signup/instructor-registration");
  };

  return (
    <div>
      <AuthNavBar />
      <div className="min-h-screen bg-[#EFEFFD] px-4 pt-16 sm:px-6 sm:pt-20 lg:px-8 lg:pt-32 pb-10 sm:pb-14 lg:pb-20">
        <div className="mx-auto w-full max-w-[1061px]">
          <div className="relative mb-10 flex min-h-[40px] items-center justify-center px-11 sm:mb-16 sm:min-h-[48px] sm:px-14 lg:mb-28 lg:min-h-[51px] lg:px-16">
            <button
              type="button"
              aria-label="Go back"
              className="absolute left-0 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center sm:h-11 sm:w-11 lg:h-[51px] lg:w-[51px] [&_svg]:h-full [&_svg]:w-full"
              onClick={() => navigate("/")}
            >
              <BACKARROW />
            </button>
            <h2 className="text-center text-2xl font-semibold leading-7 text-black sm:text-3xl sm:leading-8 lg:text-[40px] lg:leading-10">
              Choose Your Role
            </h2>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-8 md:gap-12 lg:gap-[140px]">
            {roleOptions.map((role) => {
              const isSelected = selectedRole === role.value;

              return (
                <button
                  key={role.value}
                  type="button"
                  onClick={() => handleRoleSelect(role.value)}
                  className={`rounded-[18px] border bg-[#F5F5F5] px-4 py-6 text-center shadow-[2px_3px_5.7px_-1px_#00000026] transition-all duration-200 sm:px-6 sm:py-8 lg:px-8 lg:py-10 ${
                    isSelected
                      ? "border-[#923D8C] ring-2 ring-[#923D8C]/25"
                      : "border-transparent hover:border-[#C9C1D3]"
                  }`}
                >
                  <div className="mx-auto flex h-28 w-28 items-center justify-center sm:h-44 sm:w-[170px] lg:h-[238px] lg:w-[232px]">
                    <img
                      src={role.icon}
                      alt={role.label}
                      className="h-full w-full object-cover object-center"
                    />
                  </div>
                  <p className="mt-2 text-xl font-semibold leading-7 tracking-[6%] text-black sm:mt-1 sm:text-2xl sm:leading-8 lg:text-[34px] lg:leading-10">
                    {role.label}
                  </p>
                </button>
              );
            })}
          </div>

          <p className="mt-10 text-center text-[15px] font-['Work_Sans'] leading-[18px] text-black">
            Already have an account?{" "}
            <Link to="/login" className="text-[#923D8C]">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
